import { combineReducers } from '@ngrx/store';
import { watchListsStateReducer } from './state/watch-lists-state.reducer';
import { WatchListsCommonStoreState } from './watch-lists-common.model';

export const watchListsCommonReducer = combineReducers<WatchListsCommonStoreState>(
{
    state: watchListsStateReducer,
});
